import { render, staticRenderFns } from "./Whitelist.vue?vue&type=template&id=9ad15d72"
import script from "./Whitelist.vue?vue&type=script&lang=js"
export * from "./Whitelist.vue?vue&type=script&lang=js"
import style0 from "./Whitelist.vue?vue&type=style&index=0&id=9ad15d72&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports